import api from './../helpers/api'

class WharehouseService {

    create_wharehouse(wharehouse) {
        return api.post('/addWharehouse', {
            name:           wharehouse.name,
            location:       wharehouse.location,
            description:    wharehouse.description || '',
            has_pos:        !!wharehouse.has_pos,
            is_main_store:  !!wharehouse.is_main_store,
        });
    }

    get_wharehouses(includeInactive = false) {
        return api.get('/get_wharehouses', { params: includeInactive ? { include_inactive: 1 } : {} });
    }

    toggle_active(id) {
        return api.post(`/wharehouse/${id}/toggle_active`);
    }

    get_pos_warehouses() {
        return api.get('/get_pos_warehouses');
    }

    get_wharehouse(id) {
        return api.post(`/get_wharehouse/${id}`);
    }

    edit_wharehouse(form) {
        return api.post(`/edit_wharehouse/${form.id}`, {
            name:           form.name,
            location:       form.location,
            description:    form.description || '',
            has_pos:        !!form.has_pos,
            is_main_store:  !!form.is_main_store,
        });
    }

    delete_wharehouse(id) {
        return api.post(`/delete/${id}`);
    }

    get_products_per_wharehouse(id) {
        return api.post(`/get_wharehouse_products/${id}`);
    }

    get_sproducts_per_wharehouse(id) {
        return api.post(`/get_swharehouse_products/${id}`);
    }

    transfer_product(transfer) {
        return api.post('/transproduct', {
            product_id:     parseInt(transfer.product_id),
            from_wharehouse: parseInt(transfer.from_wharehouse),
            to_wharehouse:  parseInt(transfer.to_wharehouse),
            quantity:       transfer.quantity,
            description:    transfer.description || '',
            notes:          transfer.notes || null,
        });
    }

    get_transfers(params = {}) {
        return api.get('/get_transfers', { params });
    }

    wharehouse_items() {
        return api.get('/wharehouse_items');
    }

    saved_damaged(product, wharehouse_name) {
        return api.post('/saved_damaged', { product, wharehouse_name });
    }

    edit_quantity(product, wharehouse_id) {
        return api.post('/edit_quantity', { product, wharehouse_id });
    }

    stock_in(data) {
        return api.post('/stock_in', data);
    }

    stock_out(data) {
        return api.post('/stock_out', data);
    }

    replace_damaged(data) {
        return api.post('/replace_damaged', data);
    }
}

export default new WharehouseService;
